import React from 'react';

import { Header, Eyebrow } from 'formlabs-web-components/Type';
import Card from '../../../../common/components/content/Card';

import './Resources.module.css';

const List = ({ resources }) => (
  <div styleName="posts">
    {resources.map(resource => {
      return (
        <Card
          key={resource.id}
          url={resource.url}
          imageConstraint="300px"
          imagePosition="left"
          bgColor="white"
          image={resource.listing_image}
          padding="35px"
          internalPadding="none"
          eyebrowText={resource.type}
          titleStyle="thin"
          title={resource.title}
          borderTopBottom={true}
          collapseBorder={true}
        />
      );
    })}
  </div>
);

export default List;
